const useCalculateTotalPriceForAllMemberships = (data?: MemberShipDataTypes[]): number => {
  let totalPriceForAllMemberships = 0;

  data?.forEach((membership) => {
    let totalPriceForMembership = 0;
    if (membership.divisiondata.length === 0) {
      totalPriceForMembership += membership.basicprice;
    } else if (membership.editable && ![2, 4, 5].includes(membership.paymenttypeidx)) {
      totalPriceForMembership += membership.basicprice;
      membership.divisiondata.forEach((item) => {
        if (item.recommendyn) {
          totalPriceForMembership += item.tidprice;
        }
      });
    } else if ([2, 4, 5].includes(membership.paymenttypeidx)) {
      totalPriceForMembership += membership.basicprice;
    } else {
      totalPriceForMembership += membership.basicprice + membership.divisionprice;
    }

    totalPriceForAllMemberships += totalPriceForMembership * membership.count;
  });

  return totalPriceForAllMemberships;
};

export default useCalculateTotalPriceForAllMemberships;
